<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <template v-if="paso == 1">
                <h2>Selección de documentos</h2>
                <DropZone></DropZone>
            </template>
            <template v-if="paso == 2">
                <h2>Seleccionar {{ tipoDocumento }}</h2>
                <DropZone></DropZone>
            </template>
            <template v-if="paso == 3">
                <h2>Escoger destino</h2>
                <ul class="actionList">
                    <li class="tipodocumento" @click="paso = 4;">
                        <div style="display:flex; align-items: center;">
                            <div class="icono">
                                <img src="@/assets/carpetageneral.png" width="70%" />
                            </div>
                            <p style="margin:0px;">En una carpeta general<br><small style="color:darkgray">Envía todos los archivos que cargues por empresa, área, centro o departamento</small></p>
                        </div>
                    </li>
                    <li class="tipodocumento" @click="paso = 4;">
                        <div style="display:flex; align-items: center;">
                            <div class="icono">
                                <img src="@/assets/carpetapersonal.png" width="70%" />
                            </div>
                            <p style="margin:0px;">Dentro de una carpeta personal<br><small style="color:darkgray">Envía todos los archivos que cargues a la carpeta de los usuarios que selecciones</small></p>
                        </div>
                    </li>
                    <li class="tipodocumento" @click="paso = 4;">
                        <div style="display:flex; align-items: center;">
                            <div class="icono">
                                <img src="@/assets/dni.png" width="70%" />
                            </div>
                            <p style="margin:0px;">Por el nombre del archivo<br><small style="color:darkgray">Lee el nombre del archivo y se lo envía al usuario correspondiente</small></p>
                        </div>
                    </li>
                    <li class="tipodocumento" @click="paso = 4;">
                        <div style="display:flex; align-items: center;">
                            <div class="icono">
                                <img src="@/assets/contenido.png" width="70%" />
                            </div>
                            <p style="margin:0px;">Por el contenido del archivo<br><small style="color:darkgray">Lee el contenido del archivo y se lo envía al usuario correspondiente</small></p>
                        </div>
                    </li>
                </ul>
            </template>
            <template v-if="paso == 4">
                <h2>Acciones</h2>
                <div style="display:flex; flex-direction: column;">
                <el-switch v-model="acciones.notificacion" active-text="Notificación de la publicación"/>
                <el-switch v-model="acciones.recordatorioLectura" active-text="Recordatorio de lectura"/>
                <el-switch v-model="acciones.firma" active-text="Firma del destinatario"/>
                <el-switch v-model="acciones.recordatorioFirma" active-text="Recordatorio de firma"/>
                <el-switch v-model="acciones.caducidadProgramada" active-text="Caducidad programada"/>
            </div>
            </template>
            <div style="display:flex;">
                <el-button type="primary" icon="Back" @click="paso = --paso" :disabled="leftDisabled" />
                <el-button type="primary" icon="Right" :disabled="rightDisabled" @click="paso = ++paso" />
            </div>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
import DropZone from '../components/inputs/DropZone.vue';
export default {
    name: 'EnvioDocumentos',
    watch: {
    },
    components: {
        DropZone
    },
    data() {
        return {
            loading: false,
            router: this.$router,
            paso: 1,
            tipoDocumento: '',
            file: [],
            acciones: {},
        }
    },
    mounted() {

    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio'
        ]),
        leftDisabled() {
            return false;
        },
        rightDisabled() {
            let respuesta = false;
            switch (this.paso) {
                case 2:
                    if (this.file.count == 0) {
                        respuesta = true;
                    }
                    break;
            }
            return respuesta;
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores'
        ]),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;
        padding: 0px;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }
}
</style>